module.exports = __webpack_public_path__ + "static/media/iconLibrary.7c74c22d.svg";